import { render } from "./StockStatus.vue?vue&type=template&id=3ce77fa3"
import script from "./StockStatus.vue?vue&type=script&lang=js"
export * from "./StockStatus.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__